import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { useState } from 'react';
import ReactWordcloud from '../react-wordcloud';
import words from '../words';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "transitions"
    }}>{`Transitions`}</h1>
    <p><inlineCode {...{
        "parentName": "p"
      }}>{`react-wordcloud`}</inlineCode>
      {` handles updating D3 transitions when `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`words`}</inlineCode>
      {`, `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`size`}</inlineCode>
      {` and `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`options`}</inlineCode>
      {` prop change. The following example demonstrates this behavior.`}</p>
    <Playground mdxType="Playground">
      {() => {
        const [optionsFlag, toggleOptionsFlag] = useState(false);
        const [wordsFlag, toggleWordsFlag] = useState(false);
        const options = optionsFlag ? undefined : {
          fontFamily: 'impact'
        };
        const updatedWords = wordsFlag ? words : words.slice(0, 50);
        return <>
        <button onClick={() => toggleOptionsFlag(!optionsFlag)}>
          Update options
        </button>
        <button onClick={() => toggleWordsFlag(!wordsFlag)}>
          Update words
        </button>
        <ReactWordcloud words={updatedWords} options={options} mdxType="ReactWordcloud" />
      </>;
      }}
    </Playground>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      